var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Tooltip } from '@mui/material';
const CopyToClipboard = ({ copyText, copyTooltip = 'Copy to clipboard', copyTooltipSuccess = 'Copied', children, style, tooltipProps = {}, tooltipPlacement = 'bottom' }) => {
    const [tooltip, setTooltip] = useState(copyTooltip);
    const copyToClipBoard = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (!navigator.clipboard) {
                const textArea = document.createElement('textarea');
                textArea.value = copyText;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                setTooltip(copyTooltipSuccess);
                return;
            }
            yield navigator.clipboard.writeText(copyText);
            setTooltip(copyTooltipSuccess);
        }
        catch (ex) {
            console.error('Error while copying text to clipboard', ex);
        }
    });
    return (_jsx(Tooltip, Object.assign({ title: tooltip, placement: tooltipPlacement }, tooltipProps, { children: _jsx("div", Object.assign({ onMouseEnter: () => { setTooltip(copyTooltip); }, onClick: copyToClipBoard, style: style }, { children: children })) })));
};
export default CopyToClipboard;
//# sourceMappingURL=index.js.map